import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./UnividCard.module.css";

const UnividCard = ({
  children,
  useDefaultWidth = true,
  padding = "normal",
  overflow = "auto",
  selected = false,
  customPadding = null,
  displayBorder = true,
  noBorderWidth = false,
}) => {
  const className = classNames(styles.UnividCard, {
    [styles.DefaultWidth]: useDefaultWidth,
    [styles.Border]: displayBorder,
    [styles.PaddingSlim]: padding === "slim",
    [styles.PaddingNone]: padding === "none",
    [styles.Selected]: selected,
    [styles.NoBorderWidth]: noBorderWidth,
  });

  const styleObject = {};
  if (!overflow) {
    styleObject.overflow = overflow;
  }
  if (customPadding != null) {
    styleObject.padding = customPadding;
  }

  return (
    <div className={className} style={styleObject}>
      {children}
    </div>
  );
};

UnividCard.propTypes = {
  children: PropTypes.any,
  useDefaultWidth: PropTypes.bool,
  padding: PropTypes.oneOf(["normal", "slim"]),
  customPadding: PropTypes.string,
  overflow: PropTypes.string,
};

export default UnividCard;
